import { DestroyRef, Directive, DOCUMENT, Inject, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BrandingService } from '@ideals/services/branding';

@Directive({
  selector: '[idealsAppTheme]',
  standalone: false
})
export class AppThemeDirective implements OnInit, OnDestroy {
  private _prevThemeClassName: string;

  private readonly _destroyRef = inject(DestroyRef);

  constructor(
    private readonly _brandingService: BrandingService,
    @Inject(DOCUMENT)
    private readonly _document: Document,
    private readonly _renderer: Renderer2
  ) {
  }

  public ngOnInit(): void {
    this._brandingService.getApplicationThemeClassName()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((themeClassName) => {
        if (this._prevThemeClassName) {
          this._renderer.removeClass(this._document.body, this._prevThemeClassName);
        }

        this._prevThemeClassName = themeClassName;
        this._renderer.addClass(this._document.body, themeClassName);
      });
  }

  public ngOnDestroy(): void {
    this._renderer.removeClass(this._document.body, this._prevThemeClassName);
  }
}
